import authRoutes from "./authRoutes";
import dashboardRoutes from "./dashboardRoutes";
import masterDataRoutes from "./masterDataRoutes";
import employeeRoutes from "./employeeRoutes";
import offerLetterRoutes from "./offerLetterRoutes";
import interviewRoutes from "./interviewRoutes";
import ticketRoutes from "./ticketRoutes";
import leadsRoutes from "./leadsRoutes";
import statusRoutes from "./statusRoutes";
import loanApplicationRoutes from "./loanApplicationRoutes";
import leaveRoutes from "./leaveRoutes";
import juniorRoutes from "./juniorRoutes";
import expenseRoutes from "./expenseRoutes";
import corporateDsaRoutes from "./corporateDsaRoutes";
import invoiceRoutes from "./invoiceRoutes";
import gstRoutes from "./gstRoutes";
import manualGstRoutes from "./manualGstRoutes";
import billingRoutes from "./billingRoutes";
import dsaRoutes from "./dsaRoutes";
import tdsRoutes from "./tdsRoutes";
import clawbackRoutes from "./clawbackRoutes";

// Each domain file lazy-loads its own page components and exports its own
// {path, element, protected} list — this file just combines them into the
// one array App.js maps to <Route> elements. Adding a new page means
// adding an entry to the right domain file (or a new one), never touching
// App.js.
const appRoutes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...masterDataRoutes,
  ...employeeRoutes,
  ...offerLetterRoutes,
  ...interviewRoutes,
  ...ticketRoutes,
  ...leadsRoutes,
  ...statusRoutes,
  ...loanApplicationRoutes,
  ...leaveRoutes,
  ...juniorRoutes,
  ...expenseRoutes,
  ...corporateDsaRoutes,
  ...invoiceRoutes,
  ...gstRoutes,
  ...manualGstRoutes,
  ...billingRoutes,
  ...dsaRoutes,
   ...tdsRoutes,
     ...clawbackRoutes,
];

export default appRoutes;
